import { FormGroupProps } from "reactstrap";
import styled from "styled-components";

interface FormGroupContainer {
  bg?: string;
  visible?: boolean;
  pTB?: any;
  jC?:string;
}

export const FormGroupContainer = styled.div`
  background-color: ${(p: FormGroupContainer) =>
    p.bg ? p.bg : "var(--color-rosa)"};
  display: ${(p: FormGroupContainer) => (p.visible ? "flex" : "none")};
  opacity: 0.7;
  flex-direction: row;
  flex: 1 1 0px;
  align-items: center;
  justify-content: ${(p: FormGroupContainer) => (p.jC ? p.jC : "flex-end")};
  padding: ${(p: FormGroupContainer) => (p.pTB ? p.pTB : "0.5rem")} 0.8rem;
  margin: 0.3rem;
  font-family: MontserratRegular;
`;

interface FormErrorContainer {
  visible?: boolean;
}

export const FormErrorContainer = styled.div`
  display: ${(p: FormErrorContainer) => (p.visible ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

interface Label {
  widthPercentage: number;
}

export const Label = styled.label`
  width: ${(p: Label) => p.widthPercentage + "%"};
  display: block;
  // white-space: nowrap;
  color: black;
  font-size: clamp(1.1rem, 2.5vw, 1rem);
  font-weight: 500;
  margin-right: 10px;
  margin-left: 10px;
  text-align: right;
  padding: 0;
`;

interface LabelError {
  widthPercentage: number;
}

interface ErrorLabel {
  textColor?: string;
}

export const LabelError = styled.label`
  width: 100%;
  display: block;
  white-space: nowrap;
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  color: ${(props: ErrorLabel) => props.textColor};
  text-align: right;
  padding-right: 20px;
`;

interface LabelValue {
  widthPercentage: number;
}

export const LabelValue = styled.label`
  width: ${(p: LabelValue) => 100 - p.widthPercentage + "%"};
  color: black;
  font-size: clamp(1.1rem, 2.5vw, 1rem);
  font-weight: 400;
  margin-right: 10px;
  margin-left: 10px;
  text-align: left;
`;

interface InputText {
  widthPercentage: number;
}

export const InputText = styled.input`
  width: ${(p: InputText) => 100 - p.widthPercentage + "%"};
  height: 2rem;
  display: block;
  border-radius: 52px;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  padding: 1rem;
`;

interface InputTextArea {
  widthPercentage: number;
}

export const InputTextArea = styled.textarea`
  width: ${(p: InputTextArea) => 100 - p.widthPercentage + "%"};
  min-height: 2rem;
  display: block;
  border-radius: 22px;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  padding: 1rem;
  resize: none;
`;

interface InputSelect {
  widthPercentage: number;
  placeholder?: any
}

export const InputSelect = styled.select`
  width: ${(p: InputTextArea) => 100 - p.widthPercentage + "%"};
  cursor: pointer;
  height: 2rem;
  display: block;
  border-radius: 52px;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  padding: 0.2rem 0.7rem;
`;

export const InputCheckbox = styled.input.attrs({ type: "checkbox" })`
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 52px;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  padding: 1rem;
`;

interface InputFile {
  widthPercentage: number;
}

export const InputFile = styled.input.attrs({ type: "file" })`
  width: ${(p: InputFile) => 100 - p.widthPercentage + "%"};
  display: none;
  height: 2rem;
`;

export const FileButton = styled.label`
  background-color: #0079ab;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  width: 4rem;
  height: 2rem;
  border-radius: 52px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  margin-right: 4px;
`;

interface ImageContainer {
  widthPercentage: number;
}

export const ImageContainer = styled.div`
  width: ${(p: ImageContainer) => 100 - p.widthPercentage + "%"};
  height: fit-content;
  background-color: rgba(29, 18, 12, 0.2);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 65%;
  border: none;
`;
